import React, { useEffect } from 'react';
// import { Helmet } from "react-helmet";
import './style.scss';
import { useNavigate } from 'react-router-dom';

const NotificationSuccess: React.FC = () => {


  const navigate = useNavigate()

  useEffect(() => {
    setTimeout(() => {
      navigate('/checkin/buy-packages')
    }, 5000)
  });

  return (
    <div className='checkin-page checkin-notification'>
      <div className="bg-img">
        <img src="/images/checkin/ellipse-bg.png" alt="" />
      </div>
      <div className="content-block mw-850">
        <div className="img-box">
          <img src="/images/checkin/icon-success.png" alt="" />
        </div>
        <div className="title cl-F9D361">Successful Verification!</div>
        <div className="sum cl-fff">Your identity data at the casino<br></br>has been saved</div>
      </div>
    </div>
  );
}

export default NotificationSuccess;
